/** LaunchDarkly flag key (dashboard). */
export const LAUNCHDARKLY_FLAG_KEYS = {
  /**
   * Slice 9 kill switch for Glofox integrator import (AES-358).
   * OFF / unavailable hides imported Dev Portal UX (fail-closed).
   * Local (LD disabled) defaults to ON.
   */
  integratorSync: "api-portal-integrator-sync",
  /**
   * Slice 11 kill switch for the live credential flow (AES-387).
   * OFF / unavailable keeps live review as it is today (fail-closed).
   * Local (LD disabled) defaults to ON.
   */
  liveCredentials: "api-portal-live-credentials",
} as const;

/** camelCase key returned by `useFlags()` for `api-portal-integrator-sync`. */
export const LD_INTEGRATOR_SYNC_FLAG = "apiPortalIntegratorSync" as const;

/** camelCase key returned by `useFlags()` for `api-portal-live-credentials`. */
export const LD_LIVE_CREDENTIALS_FLAG = "apiPortalLiveCredentials" as const;
